<template>
  <!-- 空状态组件 -->
  <div
    class="div_none"
    :class="props.position == 'absolute' ? 'pos_cen' : ''"
    :style="props.style"
  >
    <img
      draggable="false"
      :src="props.img"
      alt=""
      :style="{ width: props.imgSize }"
    />
    <div class="t_none">
      <slot name="title"></slot>
    </div>
    <p v-if="!$slots.title" class="t_none" v-html="props.title"></p>
  </div>
</template>

<script setup>
// 空状态组件
import { defineProps } from "vue";

const props = defineProps({
  title: { type: String, required: false, default: "已经没有更多内容喽~" },
  position: { type: String, required: false, default: "static" },
  style: { type: Object, required: false },
  imgSize: { type: String, required: false, default: "300px" },
  img: {
    type: String,
    required: false,
    default: require("@/assets/image/type/placewait.png"),
  },
});
</script>
  
<style lang="scss" scoped>
.div_none {
  // width: 100%;
  text-align: center;
  user-select: none;
  .t_none {
    color: #999999;
    font-size: 16px;
    margin-top: 15px;
  }
}
@media screen and (max-width: 768px) {
  .div_none {
    text-align: center;
    user-select: none;
    .t_none {
      color: #999999;
      font-size: 0.16rem;
      margin-top: 0.15rem;
    }
    > img {
      width: 50% !important;
    }
  }
}
</style>